import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';
import { Banche,BancheService } from 'my-lib-sanfelici';



@Component({
  selector: 'app-banche-create',
  templateUrl: './banche-create.component.html',
  styleUrls: ['./banche-create.component.css']
})
export class BancheCreateComponent implements OnInit {
banca: Banche;
abi: string;
  constructor(
    private router: Router,
    private bancheservice: BancheService
  ) { }

  ngOnInit() {
    this.banca = {id: null,
      descrizione: null,
      attivo: true, bicswift: null, ibann: null, intestazione: null};
  }
  submit() {
    this.bancheservice.create( this.banca).then();

    this.router.navigate(['/banche']);

  }

}
